import React, { useState, } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import NcDmvHandicapDetails from './NcDmvHandicapDetails';

const NcDmvHandicapPlacardModal = ({ selectedHandicapPlacard, }) => {
  const [ show, setShow, ] = useState(false);

  return (
    <>
      <Button variant="primary" onClick={() => setShow(true)}>
        Details
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Driver&apos;s License Number: {selectedHandicapPlacard.driversLicenseNumber}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            return show
              ? <NcDmvHandicapDetails selectedHandicapPlacard={selectedHandicapPlacard} />
              : undefined;
          })()}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </>
  );
};

export default NcDmvHandicapPlacardModal;

NcDmvHandicapPlacardModal.propTypes = {
  selectedHandicapPlacard: PropTypes.instanceOf(Object).isRequired,
};
